// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__38K3y","textarea":"TextArea_textarea__33ycI","no_resize":"TextArea_no_resize__3X2EK","line_numbers":"TextArea_line_numbers__3wscX"};